
import React, { Component } from 'react';

import { TicketSelection } from '../selecttickets';
import { EventDateInfoList } from '.';
import { PackageInfoModel } from '../../../mvcapi/models/common/package-info-model';
import { produce } from 'immer';
import MarkDown from 'react-markdown';
import TranslatorManager from 'ts-translate-js';
import { Button } from '@tsinternetsale/common';

const tr = TranslatorManager.boundTR;

export type PackageEventSelectionProps = {
    packageInfo: PackageInfoModel,
    selectedEventDateIDs: number[],
    overview: boolean,
    hidePackageEventDetailLink: boolean,
    onContentChange: () => void,
    onBuyClick: () => void,
    homeUrl: string,
    onChangeEventDates: (eventDateIds: number[]) => void,
    handleStepDone: () => void,
    onModifyThisStep: () => void,
    onPromoInfoUpdated: () => void
};

export type PackageEventSelectionState = {
    //type: string,
    //selectedIDs: number[],
    mandatorySelectedIDs: number[], // NE Pas mettre dans le store c'est juste un petit validateur. À la limite, il pourrait être auto calculé à la place...
    //salesurls: {}
};

export class PackageEventSelection extends Component<PackageEventSelectionProps, PackageEventSelectionState> {
    constructor(props) {
        super(props);

        this.state = {
            //type: null,
            //selectedIDs:[],
            mandatorySelectedIDs:[],
            //salesurls: {}
        };

        this.handleStepDone = this.handleStepDone.bind(this);
        this.handleEventDateClick = this.handleEventDateClick.bind(this);
    }

    componentDidMount() {
        // if(this.props.selectedEventDateIDs != null)
        //     this.setState({ selectedIDs: this.props.selectedEventDateIDs });

        if(this.props.onContentChange !== undefined) this.props.onContentChange();
    }

    componentDidUpdate() {
        if(this.props.onContentChange !== undefined) this.props.onContentChange();
    }

    handleStepDone(success) {
        if(this.props.handleStepDone !== undefined && success) this.props.handleStepDone();
    }

    handleMandatoryEventDateClick(eventDateID, isSelected){
        const indexInSelected = this.state.mandatorySelectedIDs.indexOf(eventDateID);

        if(!isSelected) { // Then select it
            if(indexInSelected === -1)
                this.state.mandatorySelectedIDs.push(eventDateID); // TODO: Changer ça en immutable!
        } else if(indexInSelected > -1) { // Unselect it
            this.state.mandatorySelectedIDs.splice(indexInSelected, 1); // TODO: Changer ça en immutable!
        }

        this.setState({ mandatorySelectedIDs: this.state.mandatorySelectedIDs });
    }

    handleEventDateClick(eventDateID: number, isSelected: boolean, isMandatory: boolean) {

        if (isMandatory)
            this.handleMandatoryEventDateClick(eventDateID, isSelected);

        const newSelectedIds = produce(this.props.selectedEventDateIDs, draft => {
            const indexInSelected = draft.indexOf(eventDateID);
            if(!isSelected) { // Then select it
                if(indexInSelected === -1)
                    draft.push(eventDateID);
            } else { // Unselect it
                if(indexInSelected > -1)
                    draft.splice(indexInSelected, 1);
            }
        });

        if(this.props.onChangeEventDates !== undefined) this.props.onChangeEventDates(newSelectedIds);
    }

    render() {
        let content = null;

        if(this.props.packageInfo != null) {
            let generalTitle = tsapp.tr("buypackage.overviewtitle");
            if(!this.props.overview && !this.props.packageInfo.IsFixedPackage) {
                if(this.props.packageInfo.EventDateMinNumber == this.props.packageInfo.EventDateMaxNumber)
                    generalTitle = tsapp.trN("Choisissez un evenement parmi les suivants", "Choisissez {n} evenements parmi les suivants", { n: this.props.packageInfo.EventDateMinNumber });
                else
                    generalTitle = tsapp.tr("buypackage.betweeneventstitle", {min: this.props.packageInfo.EventDateMinNumber, max: this.props.packageInfo.EventDateMaxNumber });
            }

            const displayEventTitles = (!this.props.overview && this.props.packageInfo.MandatoryEventDateInfos.length > 0);

            let titleMandatoryEventDates = null;
            let titleEventDates = null;
            if(displayEventTitles) {
                if (this.props.packageInfo.MinMandatoryDateRequired != 0 && this.props.packageInfo.MaxMandatoryDateRequired){
                    if (this.props.packageInfo.MinMandatoryDateRequired == this.props.packageInfo.MaxMandatoryDateRequired)
                        titleMandatoryEventDates = <h4>{tsapp.tr("Vous devez choisir {n} items de la liste suivante", {n: this.props.packageInfo.MinMandatoryDateRequired})}</h4>;
                    else
                        titleMandatoryEventDates = <h4>{tsapp.tr("Vous devez choisir de {min} à {max} items de la liste suivante", {min: this.props.packageInfo.MinMandatoryDateRequired, max: this.props.packageInfo.MaxMandatoryDateRequired })}</h4>;
                    titleEventDates = <h4>{tsapp.tr("Compléter votre forfait parmi les événements suivants")}</h4>;
                }
                else{
                    titleMandatoryEventDates = <h4>{tsapp.tr("buypackage.mandatorytitle")}</h4>;
                    titleEventDates = <h4>{tsapp.tr("buypackage.eventtitle")}</h4>;
                }
            }

            let ticketSelection = null;
            let specialMessage;

            if(this.props.selectedEventDateIDs.length >= this.props.packageInfo.EventDateMinNumber
                && this.props.selectedEventDateIDs.length <= this.props.packageInfo.EventDateMaxNumber
                && (this.props.packageInfo.MandatoryEventDateInfos.length === 0
                || (this.props.packageInfo.MinMandatoryDateRequired == 0 && this.props.packageInfo.MaxMandatoryDateRequired == 0 && this.state.mandatorySelectedIDs.length > 0)
                || ((this.props.packageInfo.MinMandatoryDateRequired != 0 && this.state.mandatorySelectedIDs.length >= this.props.packageInfo.MinMandatoryDateRequired) && (this.props.packageInfo.MaxMandatoryDateRequired != 0 && this.state.mandatorySelectedIDs.length <= this.props.packageInfo.MaxMandatoryDateRequired))
                )
            ) {
                if(this.props.packageInfo.Use2024UnrestrictedSale) {
                    if(!this.props.packageInfo.IsFixedPackage) {
                        if(!this.props.overview)
                            ticketSelection = <div>
                                <Button onClick={this.handleStepDone}>{tr(`Suivant`)}</Button>
                            </div>;
                        else
                            ticketSelection = <div>
                                <button className="btn btn-default btn-xs" type="button" onClick={this.props.onModifyThisStep}>{tr("Changer")}</button>
                            </div>;
                    }
                } else
                    ticketSelection = (
                        <TicketSelection 
                            hiddenPromo={undefined}
                            suggestedQtySales={undefined}
                            internetTicketQTYMultipleOf={undefined}
                            autoFindTicket={undefined}
                            forceSectionInPromo={undefined}
                            seePromoLink={undefined}
                            packages={undefined}
                            packageNumberForEventDate={undefined}
                            preferredSelectedSectionId={undefined}
                            scheduleRange={undefined}
                            hideBestTicketSelection={undefined}
                            integ={undefined}
                            onBuyClick={undefined}

                            packageID={this.props.packageInfo.PackageID}
                            eventDateIDs={this.props.selectedEventDateIDs}
                            promoInfo={this.props.packageInfo.PromoInfo} 
                            maxQty={4}
                            productType={"Ticket"}
                            limitQtySales={this.props.packageInfo.LimitQtySales}
                            sections={this.props.packageInfo.Sections}
                            overview={this.props.overview}
                            onPromoUpdated={this.props.onPromoInfoUpdated}
                            onContentChange={this.props.onContentChange}
                            onFoundTickets={this.handleStepDone}
                            onModifyThisStep={this.props.onModifyThisStep}>
                        </TicketSelection>
                    );

                if (this.props.packageInfo.ImportantInfo)
                    specialMessage = <div className="specialMessage">
                        <div className="alert alert-warning" role="alert"><MarkDown source={this.props.packageInfo.ImportantInfo}></MarkDown></div>
                    </div>;
            }
            else {
                if(this.props.selectedEventDateIDs.length < this.props.packageInfo.EventDateMinNumber)
                    ticketSelection = <div className="alert alert-warning text-center"><strong>{tsapp.trN("Il vous manque encore un evenement dans votre choix pour continuer.", "Il vous manque encore {n} evenements dans votre choix pour continuer.", { n: (this.props.packageInfo.EventDateMinNumber - this.props.selectedEventDateIDs.length) })}</strong></div>;
                else if(this.props.selectedEventDateIDs.length > this.props.packageInfo.EventDateMaxNumber)
                    ticketSelection = <div className="alert alert-warning text-center"><strong>{tsapp.tr("Vous avez dépassé le nombre d'evenements autorises de {n} pour continuer.", { n: (this.props.selectedEventDateIDs.length - this.props.packageInfo.EventDateMaxNumber) })}</strong></div>;
                else if(this.props.packageInfo.MinMandatoryDateRequired != 0 && this.state.mandatorySelectedIDs.length < this.props.packageInfo.MinMandatoryDateRequired)
                    ticketSelection = <div className="alert alert-warning text-center"><strong>{tsapp.trN("Il vous manque encore un evenement obligatoire dans votre choix pour continuer.", "Il vous manque encore {n} evenements oligatoires dans votre choix pour continuer.", { n: (this.props.packageInfo.MinMandatoryDateRequired - this.props.selectedEventDateIDs.length) })}</strong></div>;
                else if(this.props.packageInfo.MaxMandatoryDateRequired != 0 && this.state.mandatorySelectedIDs.length > this.props.packageInfo.MaxMandatoryDateRequired)
                    ticketSelection = <div className="alert alert-warning text-center"><strong>{tsapp.tr("Vous avez dépassé le nombre d'evenements obligatoire autorises de {n} pour continuer.", { n: (this.state.mandatorySelectedIDs.length - this.props.packageInfo.MaxMandatoryDateRequired) })}</strong></div>;
                else if(this.props.packageInfo.MinMandatoryDateRequired == 0 && this.props.packageInfo.MaxMandatoryDateRequired == 0 && this.state.mandatorySelectedIDs.length === 0)
                    ticketSelection = <div className="alert alert-warning text-center"><strong>{tsapp.tr("Il vous manque encore un evenement obligatoire dans votre choix pour continuer.")}</strong></div>;
            }


            content = (
                <div>
                    <h3>{generalTitle}</h3>
                    <div className="package-event-date-list">
                        <div className="row">
                            <div className="col-xs-12">
                                {titleMandatoryEventDates}
                                <EventDateInfoList items={this.props.packageInfo.MandatoryEventDateInfos}
                                                    hidePackageEventDetailLink={this.props.hidePackageEventDetailLink}
                                                    onEventDateClick={this.handleEventDateClick}
                                                    selectedItemIDs={this.props.selectedEventDateIDs}
                                                    isFixedPackage={this.props.packageInfo.IsFixedPackage}
                                                    homeUrl={this.props.homeUrl}
                                                    overview={this.props.overview}
                                                    isMandatory={true}>
                                </EventDateInfoList>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-xs-12">
                                {titleEventDates}
                                <EventDateInfoList items={this.props.packageInfo.EventDateInfos}
                                                    hidePackageEventDetailLink={this.props.hidePackageEventDetailLink}
                                                    onEventDateClick={this.handleEventDateClick}
                                                    selectedItemIDs={this.props.selectedEventDateIDs}
                                                    homeUrl={this.props.homeUrl}
                                                    isFixedPackage={this.props.packageInfo.IsFixedPackage}
                                                    overview={this.props.overview}>
                                </EventDateInfoList>
                            </div>
                        </div>
                    </div>
                    {specialMessage}
                    {ticketSelection}
                </div>
            );
        }
        return content;
    }
}


